function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.498 11.7947C19.9556 11.7938 21.3665 12.3089 22.4806 13.2487L25.6014 10.2768C24.4034 9.17215 22.9644 8.36194 21.3987 7.91047C19.8329 7.45899 18.1835 7.37866 16.5813 7.67587C14.9791 7.97308 13.4682 8.63964 12.1686 9.62265C10.8689 10.6057 9.81627 11.8781 9.09418 13.3389L12.6125 16.0507C13.0228 14.8134 13.812 13.7366 14.8683 12.9727C15.9246 12.2089 17.1945 11.7968 18.498 11.7947Z",
  fill: "#D94F3D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2946 17.9981C12.2955 17.3361 12.4028 16.6786 12.6125 16.0507L9.09418 13.3389C8.37452 14.7866 8 16.3814 8 17.9981C8 19.6148 8.37452 21.2096 9.09418 22.6573L12.6125 19.9455C12.4028 19.3176 12.2955 18.6601 12.2946 17.9981Z",
  fill: "#F2C042"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5666 16.0894H18.5458V20.384H24.2243C23.8865 21.5983 23.1125 22.6453 22.0507 23.3244L25.5418 26.0157C27.7726 24.0135 29.0834 20.7576 28.5666 16.0894Z",
  fill: "#5085ED"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.0492 23.3244C20.9703 23.942 19.7404 24.2457 18.498 24.2015C17.1945 24.1995 15.9246 23.7873 14.8683 23.0235C13.812 22.2596 13.0228 21.1828 12.6125 19.9455L9.09418 22.6573C9.9632 24.4091 11.3038 25.8837 12.9651 26.9152C14.6264 27.9467 16.5425 28.4942 18.498 28.4962C21.0712 28.5661 23.5794 27.6823 25.5403 26.0148L22.0492 23.3244Z",
  fill: "#57A75C"
});

var SvgIcGoogle = function SvgIcGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_google.dcdaeceb.svg";
export { ForwardRef as ReactComponent };